import throttle from 'lodash.throttle';
import inView from 'element-in-view';
import { getPageOffsetY, getBounds, getWindowHeight } from './util';

export class Shapes {

  constructor(root) {
    this.shapes = [];

    this.initialize();
  }

  initialize() {
    // On scroll
    window.addEventListener('scroll', throttle( (() => {
      this.onScroll();
    }) , 1000 / 60));
    // Get shapes
    this.shapes = [...document.querySelectorAll('.FloatingBrick')];
    // console.log("Init shapes: ", this.shapes);
  }

  onScroll(that) {
    const vp = getPageOffsetY();
    this.scrollShapeAnimation(vp);
  }

  scrollShapeAnimation(vp) {
    var screenHeight = window.innerHeight;
    var scrollPosition = window.scrollY;
    // Loop thorugh elements
    for (let i = 0; i < this.shapes.length; ++i) {
      // Check if list is in centre
      if (inView(this.shapes[i])) {
        var offsetTop = this.shapes[i].offsetTop;
        var elementHeight = this.shapes[i].offsetHeight;
        var scrollElementOffset = (scrollPosition + screenHeight/2);
        var rotateY = -15 + scrollElementOffset/100 * 2;
        this.shapes[i].style.transform = 'rotate(' + rotateY + 'deg)';
      }
    }
  }

}
